import { Reducer } from 'redux'

import { IntegrationsState, IntegrationTypes } from './types'

const INITIAL_STATE: IntegrationsState = {
  error: '',
  errorRenew: '',
  list: [],
  loading: false
}

const reducer: Reducer<IntegrationsState> = (
  state = INITIAL_STATE,
  { payload, type }
) => {
  switch (type) {
    case IntegrationTypes.GET_INTEGRATION_CREDENTIALS:
      return {
        ...state,
        error: '',
        errorRenew: '',
        loading: true
      }
    case IntegrationTypes.GET_INTEGRATION_CREDENTIALS_SUCCESS:
      return {
        ...state,
        list: payload.list,
        loading: false
      }
    case IntegrationTypes.GET_INTEGRATION_CREDENTIALS_FAILURE:
      return {
        ...state,
        error: payload.message,
        loading: false
      }
    case IntegrationTypes.SET_INTEGRATION_CREDENTIAL:
      return {
        ...state,
        errorRenew: '',
        loading: true
      }
    case IntegrationTypes.SET_INTEGRATION_CREDENTIAL_FAILURE:
      return {
        ...state,
        errorRenew: payload.message,
        loading: false
      }
    default:
      return state
  }
}

export default reducer
